import React, { Component } from "react";
import firebase from "../Firebase";
import { Link } from "react-router-dom";

class Create extends Component {
  constructor() {
    super();
    this.ref = firebase.firestore().collection("tracker");
    this.state = {
      projname: "",
      description: "",
      status: "",
      deployment: "",
    };
  }
  onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  };

  onSubmit = (e) => {
    e.preventDefault();

    const { projname, description, status, deployment } = this.state;

    this.ref
      .add({
        projname,
        description,
        status,
        deployment,
      })
      .then((docRef) => {
        this.setState({
          projname: "",
          description: "",
          status: "",
          deployment: "",
        });
        this.props.history.push("/");
      })
      .catch((error) => {
        console.error("Error adding document: ", error);
      });
  };

  render() {
    const { projname, description, status, deployment } = this.state;
    return (
      <div className="container" style={{ backgroundColor: "#ffffff" }}>
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3
              className="panel-title"
              style={{
                marginBottom: "1em",
                marginTop: "1em",
              }}
            >
              Add App
            </h3>
          </div>
          <div className="panel-body">
            <h4>
              <Link to="/" className="btn btn-primary">
                Apps List
              </Link>
            </h4>
            <form onSubmit={this.onSubmit}>
              <div className="form-group">
                <label htmlFor="projname">Project Name:</label>
                <input
                  type="text"
                  className="form-control"
                  name="projname"
                  value={projname}
                  onChange={this.onChange}
                  placeholder="Enter the project Name"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="description">Description:</label>
                <textarea
                  className="form-control"
                  name="description"
                  onChange={this.onChange}
                  placeholder="Description of the Project"
                  cols="80"
                  rows="2"
                  required
                >
                  {description}
                </textarea>
              </div>
              <div className="form-group">
                <label htmlFor="status">Status:</label>
                <input
                  type="text"
                  className="form-control"
                  name="status"
                  value={status}
                  onChange={this.onChange}
                  placeholder="Current status"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="deployment">Deployment Status:</label>
                <input
                  type="text"
                  className="form-control"
                  name="deployment"
                  value={deployment}
                  onChange={this.onChange}
                  placeholder="Yes if deployed No otherwise"
                />
              </div>
              <button type="submit" className="btn btn-success">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default Create;
